// extracted by css-extract-rspack-plugin
export default {"root":"KjNpEo","input":"pTFEip"};